<template>
    <!-- <Navbar /> -->
    <main class="h-screen overflow-x-hidden lg:px-10 md:px-10 px-3 relative flex flex-col-reverse items-center justify-center md:flex-row lg:flex-row bg-gradient-to-br from-gray-300 via-white to-gray-300">
      <transition name="right-accent">
        <img v-if="show" src="../assets/top-right.png" class="w-1/3 md:w-2/12 lg:w-2/12 absolute top-0 right-0 zIsland accent">
      </transition>
      <transition name="left-accent">
        <img v-if="show" src="../assets/bottom-left.png" class="w-1/3 md:w-2/12 lg:w-2/12 absolute bottom-0 left-0 zIsland accent">
      </transition>
      <transition name="zoom-fade">
        <img v-if="show" src="../assets/bg-pattern.png" class="h-screen absolute">
      </transition>
      <transition name="slide-fade">
        <div v-if="show" class="w-full md:w-4/6 lg:w-4/6 flex justify-center flex-col">
          <img src="../assets/virtualIsland.png" alt="TAYTB Virtual Island"
          class="relative zIsland lg:w-10/12 md:w-10/12 w-full island mx-auto">
        </div>
      </transition>
      <transition name="slide-content">
        <div v-if="show" class="w-full md:w-1/2 lg:w-2/6 p-5 flex relative zIsland flex-col mt-10 items-center justify-center event-info">
            <img src="../assets/eventName.png" class="w-full my-2"/>
            <div class="relative w-full">
              <div class="w-full mt-1 flex justify-center p-1">
                <!-- <flip-countdown deadline="2021-04-01 00:00:00" class="w-full flex flex-nowrap justify-center px-5"></flip-countdown> -->
                <Countdown end="April 1, 2021" showDays showHours showMinutes showSeconds :endFunction="endCountdown()"
                class="font-extrabold text-red-700"></Countdown>
              </div>
                <div class="flex justify-center w-full" >
                  <button @click.prevent="leavePage()" class="button text-white lg:w-2/3 md:w-96 w-full md:text-base bg-red hover:animate-pulse lg:py-2 lg:px-5  p-2 rounded shadow-xl bg-red-700 mt-3">Early Sign-up</button>
                </div>
            </div>
        </div>
      </transition>
    </main>
</template>

<script>
// @ is an alias to /src
// import Navbar from '@/components/Navbar'
// import FlipCountdown from 'vue2-flip-countdown'
import Countdown from 'countdown-vue'

export default {
  name: 'Home',
  components: {
    // Navbar,
    // FlipCountdown
    Countdown
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.show = !this.show
  },
  methods: {
    leavePage () {
      this.show = !this.show
      setTimeout(() => this.$router.push({ path: '/pre-signup' }), 700)
    },
    endCountdown () {
      console.log('D-Day')
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
  button {
    font-family: 'Bebas Neue', cursive;
  }
  .zIsland {
    z-index: 9;
  }
  .accent {
    max-height: 25%;
  }
  .island {
    max-height: 80vh;
    width: auto;
  }
  /* island */
  .slide-fade-enter-active {
    transition: all 1s ease;
    transition-delay: .8s;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(-50px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateX(50px);
    opacity: 0;
  }
  /* content */
  .slide-content-enter-active {
    transition: all 1s ease;
    transition-delay: .8s;
  }
  .slide-content-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-content-enter, .slide-content-leave-to {
    transform: translateX(50px);
    opacity: 0;
  }
  /* background */
  .zoom-fade-enter-active {
    transition: all .8s ease;
  }
  .zoom-fade-enter {
    transform: translateY(-50px);
    opacity: 0;
  }
  .zoom-fade-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
  /* accent top right */
  .right-accent-enter, .right-accent-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
  .right-accent-enter-active {
    transition: all .5s ease;
    transition-delay: .5s;
  }
  .right-accent-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  /* accent bottom left */
  .left-accent-enter, .left-accent-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
  .left-accent-enter-active {
    transition: all .5s ease;
    transition-delay: .3s;
  }
  .left-accent-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
</style>
